export const defaultLocale = 'ru';

export const locales = ['ru'];

export const languageNames = {
  ru: 'Русский',
};
